import { Box, Typography } from '@material-ui/core/'
import { Info } from '@scoir/tooltips'

import { Insights } from './index'

const Metrics = ({ total, last30Days }: Insights) => {
  const totalText = total || total === 0 ? total.toLocaleString() : undefined
  const change = total - last30Days

  const getLast30DaysText = () => {
    return change >= 0 ? `+${change.toLocaleString()}` : `${change.toLocaleString()}`
  }

  return (
    <>
      {totalText && (
        <Box
          display="flex"
          alignItems="center"
        >
          <Typography
            variant="h5"
            component="span"
          >{`${totalText} Interested Students`}</Typography>
          <Box
            display="flex"
            ml={1}
          >
            <Info
              outlinedIcon
              inheritColor
              tooltipProps={{ placement: 'right' }}
            >
              Your Interested Students are made up of students who add your school to their “My Colleges” list in the
              Following, Applying, or Applied status. This is your reachable audience.
            </Info>
          </Box>
        </Box>
      )}
      {last30Days && (
        <Typography
          component="span"
          variant="body2"
          color="initial"
        >
          <strong>{`${getLast30DaysText()}`}</strong> in the last 30 days
        </Typography>
      )}
    </>
  )
}

export default Metrics
